import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { N100 } from '@atlaskit/theme/colors';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddonDiscoveryPropTypes from "../../../../AddonDiscovery/constants/proptypes/AddonDiscoveryPropTypes";
import Category from "./Category";

var CategoriesStyled = _styled("div", {
  target: "ecweo2c0",
  label: "CategoriesStyled"
})("text-overflow:ellipsis;white-space:nowrap;overflow:hidden;height:18px;font-size:12px;color:", N100, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21tb24vY29tcG9uZW50cy9IaXRzL0NhdGVnb3JpZXMvQ2F0ZWdvcmllcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTbUMiLCJmaWxlIjoiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbW1vbi9jb21wb25lbnRzL0hpdHMvQ2F0ZWdvcmllcy9DYXRlZ29yaWVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTjEwMCB9IGZyb20gJ0BhdGxhc2tpdC90aGVtZS9jb2xvcnMnO1xuaW1wb3J0IEltbXV0YWJsZVByb3BUeXBlcyBmcm9tICdAYXRsYXNzaWFuL3JlYWN0LWltbXV0YWJsZS1wcm9wdHlwZXMnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBBZGRvbkRpc2NvdmVyeVByb3BUeXBlcyBmcm9tICcuLi8uLi8uLi8uLi9BZGRvbkRpc2NvdmVyeS9jb25zdGFudHMvcHJvcHR5cGVzL0FkZG9uRGlzY292ZXJ5UHJvcFR5cGVzJztcbmltcG9ydCBDYXRlZ29yeSBmcm9tICcuL0NhdGVnb3J5JztcblxuY29uc3QgQ2F0ZWdvcmllc1N0eWxlZCA9IHN0eWxlZC5kaXZgXG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBoZWlnaHQ6IDE4cHg7XG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgY29sb3I6ICR7TjEwMH07XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBDYXRlZ29yaWVzIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICBjYXRlZ29yaWVzOiBJbW11dGFibGVQcm9wVHlwZXMubGlzdC5pc1JlcXVpcmVkLFxuICAgIG9uQ2F0ZWdvcnlDbGljazogUHJvcFR5cGVzLmZ1bmMsXG4gICAgcGVyc3BlY3RpdmU6IEFkZG9uRGlzY292ZXJ5UHJvcFR5cGVzLnBlcnNwZWN0aXZlLFxuICB9O1xuXG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPENhdGVnb3JpZXNTdHlsZWQ+XG4gICAgICAgIHt0aGlzLnByb3BzLmNhdGVnb3JpZXMubWFwKChjYXRlZ29yeSwgaSkgPT4gKFxuICAgICAgICAgIDxzcGFuIGtleT17aX0+XG4gICAgICAgICAgICB7aSA+IDAgPyAnLCAnIDogJyd9XG4gICAgICAgICAgICA8Q2F0ZWdvcnlcbiAgICAgICAgICAgICAgbmFtZT17Y2F0ZWdvcnl9XG4gICAgICAgICAgICAgIG9uQ2xpY2s9e3RoaXMucHJvcHMub25DYXRlZ29yeUNsaWNrfVxuICAgICAgICAgICAgICBwZXJzcGVjdGl2ZT17dGhpcy5wcm9wcy5wZXJzcGVjdGl2ZX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9zcGFuPlxuICAgICAgICApKX1cbiAgICAgIDwvQ2F0ZWdvcmllc1N0eWxlZD5cbiAgICApO1xuICB9XG59XG4iXX0= */"));

var Categories = /*#__PURE__*/function (_Component) {
  _inherits(Categories, _Component);

  var _super = _createSuper(Categories);

  function Categories() {
    _classCallCheck(this, Categories);

    return _super.apply(this, arguments);
  }

  _createClass(Categories, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement(CategoriesStyled, null, this.props.categories.map(function (category, i) {
        return /*#__PURE__*/React.createElement("span", {
          key: i
        }, i > 0 ? ', ' : '', /*#__PURE__*/React.createElement(Category, {
          name: category,
          onClick: _this.props.onCategoryClick,
          perspective: _this.props.perspective
        }));
      }));
    }
  }]);

  return Categories;
}(Component);

_defineProperty(Categories, "propTypes", {
  categories: ImmutablePropTypes.list.isRequired,
  onCategoryClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective
});

export { Categories as default };